import MiddleNightTime from "./components/MiddleNightTime/MiddleNightTime";
import LastThirdTime from "./components/LastThirdTime/LastThirdTime";
import KohetEnamazit from "./components/KohetEnamazit";
import Info from "./components/Info";
import NavigationMenu from "./components/Menu";
import Footer from "./components/footer/Footer";
import InstallPrompt from "./components/InstallPrompt";
import { Route, Routes, Link } from "react-router-dom";
import { Typography } from "@material-tailwind/react";

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="sticky top-0 z-50 bg-white p-4 flex justify-between items-center">
        <Link to="/" className="cursor-pointer">
          <Typography variant="h4" color="blue-gray" className="font-bold">
            Muslimani.info
          </Typography>
        </Link>
        <NavigationMenu />
      </div>
      <div className="flex-1 bg-blue-gray-800">
        <Routes>
          <Route path="/" element={<MiddleNightTime />} />
          <Route path="/gjysma-e-nates" element={<MiddleNightTime />} />
          <Route path="/pjesa-e-trete-e-nates" element={<LastThirdTime />} />
          <Route path="/kohet-e-namazit" element={<KohetEnamazit />} />
          <Route path="/informacione" element={<Info />} />
        </Routes>
      </div>
      <Footer />
      <InstallPrompt />
    </div>
  );
}

export default App;
